export default "__VITE_ASSET__ChSLbHmj__"